import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class DefaultReportGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): UrlTree {
    return this.router.createUrlTree(['overview']);
  }
}
